<template>
  <container
    subHeaderTitle="정보유출안심케어<br /><b>해지하기</b>"
    subHeaderText="가입자의 정보 확인이 꼭 필요합니다.<br />본인의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <section class="form-area mb-180">
      <v-container class="py-0">
        <v-row justify="center">
          <v-col cols="12" md="4" sm="6">
            <v-form v-model="valid" ref="form" onsubmit="return false;">
              <p>휴대폰번호</p>
              <div class="d-flex">
                <v-select
                  :items="items"
                  item-text="text"
                  item-value="value"
                  v-model="teleCode"
                  solo
                />
                <v-text-field
                  v-model="cellTelNo"
                  :rules="rules.cellTelNoRules"
                  label="'-'를 제외하고 입력"
                  mask="###########"
                  solo
                  maxlength="11"
                />
              </div>
              <div class="recaptcha-area">
                <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                <div class="v-messages theme--light error--text mt-2">
                  <div class="v-messages__wrapper">
                    <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                  </div>
                </div>
              </div>
              <div>
                <v-btn class="submit" rounded block large depressed color="primary" v-on:click="submit"
                :data-ga-category="gaEvent.category.support.safeguard.termi.name" :data-ga-label="gaEvent.category.support.safeguard.termi.label1" :data-ga-action="gaEvent.actions.buttonClick"
                >해지하기</v-btn>
              </div>
              <div class="text-center mt-3">
                <v-btn class="back" text rounded @click.stop="goBack"
                :data-ga-category="gaEvent.category.support.safeguard.termi.name" :data-ga-label="gaEvent.category.support.safeguard.termi.label2" :data-ga-action="gaEvent.actions.buttonClick"
                >취소</v-btn>
              </div>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeguardTermination from "@/views/csCenter/PassSafeguardTermination.vue";

export default {
  mixins: [PassSafeguardTermination],
  name: "SafeidTermination",
  components: {
    Container
  },
  data() {
    return {
      items: [
        { text: 'SKT', value: '1' },
        { text: 'KT', value: '2' },
        { text: 'LG U+', value: '3' }
      ]
    };
  },
  computed: {
    teleCoCd() {
      return this.teleCode;
    },
  },
  methods: {
    submit(e) {
      this.gaTracking(e);
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();

      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      this.$router.push({
        name: "SafeidCert",
        params: {
          teleCoCd: this.teleCoCd,
          cellTelNo: this.cellTelNo
        }
      });
    },
    goBack(e) {
      this.gaTracking(e);
      this.$router.push({ name: 'Support' });
    }
  }
};
</script>
